import { cloneElement } from "react";
import "../../styles/common.scss";

const Row = ({
  children,
  className,
  justify,
  align,
  margin,
  fluid,
  style,
  childrenStyle,
  childrenMargin,
  onClick,
}) => {
  return (
    <div
      className={`row ${className ?? ""}${
        childrenMargin ? ` children-margin ${childrenMargin}` : ""
      }`}
      style={{
        justifyContent: justify,
        alignItems: align,
        margin,
        width: fluid && "100%",
        ...style,
      }}
      onClick={onClick}
    >
      {Array.isArray(children) && childrenStyle
        ? children.map((child) => cloneElement(child, { style: childrenStyle }))
        : children}
    </div>
  );
};

export default Row;
